import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.SERVER_URL}/api/v1/`,
  headers: {
    common: {
      'Token-Body': localStorage.getItem('Auth-Token'),
      Device: localStorage.getItem('Device-Token'),
      Email: localStorage.getItem('Email'),
      'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en',
    },
  },
  params: {
    locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en',
  },
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios.js